import {Injectable} from '@angular/core';
import {HttpClientWrapperService} from '../config/http-client-wrapper.service';

@Injectable({
  providedIn: 'root'
})
export class ListService {

  constructor(private http: HttpClientWrapperService) {
  }
  getStateList() {
    return this.http.get('samanAPI/Statistics/GetStateCodeList');
  }

  getCityList(stateID: number) {
    return this.http.get('samanAPI/Statistics/GetCityCodeList?stateCode=' + stateID, null);
  }
}
